import axios from "axios";
import { inject, injectable } from "inversify";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";
import type { IStorageLocationsRepository, StorageLocations } from "@domain/repositories/IStorageLocationsRepository";
import { TYPES } from "@utils/inversifyJS/types";

@injectable()
export class StorageLocationsRepository implements IStorageLocationsRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  async getStorageLocationsAsync(): Promise<StorageLocations> {
    return this._requestHandlerService.handleRequestAsync<StorageLocations>(() => axios.get<StorageLocations>(runtimeConfig.API_BASE_URL + API_ENDPOINTS.storageLocations));
  }
}
